import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { theme } from '../constants'
import { Color } from '../constants/color'
import { StyleProps, createStyles } from '../utils/create-styles'

export type SubtitleProps = {
  children?: ReactNode
  color?: string
  styles?: StyleProps
}

/**
 * @deprecated
 */
export const Subtitle = styled.h5<SubtitleProps>((props) => ({
  color: props.color ?? Color.DARK_GREY,
  fontSize: 13,
  fontWeight: theme.font.weight.bold,
  letterSpacing: '0.03rem',
  marginBottom: 8,
  marginTop: 0,
  textTransform: 'uppercase',
  ...createStyles(props.styles),
}))
